import {
    DataService,
    EntityManager,
    EntityQuery,
    MetadataStore,
} from 'breeze-client';
import { environment } from 'environments/environment';
import { defer, from, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { BusyService } from './busy.service';

export class LookupTypesCache {
    readonly lookupTypes$: Observable<any>;

    constructor(
        metadata: MetadataStore,
        controller: string,
        resourceName: string,
        busyService: BusyService
    ) {
        const dataService = new DataService({
            serviceName: `${environment.apiRoot}/${controller}`,
            hasServerMetadata: false,
        });

        const em = new EntityManager({
            dataService,
            metadataStore: metadata,
        });

        const lookupTypesQuery = EntityQuery.from(resourceName);
        this.lookupTypes$ = defer(() =>
            busyService.busy$(
                'Loading static data...',
                from(em.executeQuery(lookupTypesQuery))
            )
        ).pipe(
            map((result) => {
                const lookupTypes =
                    result.retrievedEntities.filter((e) => !!e.entityType) ||
                    [];
                return em.exportEntities(lookupTypes, {
                    asString: false,
                    includeMetadata: false,
                });
            }),
            shareReplay({ bufferSize: 1, refCount: false })
        );
    }
}
